import { render, staticRenderFns } from "./RolePolicyForm.vue?vue&type=template&id=9b56646e"
import script from "./RolePolicyForm.vue?vue&type=script&lang=js"
export * from "./RolePolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports